<mat-button-toggle-group class="toggle-group" [value]="selectedVisualization"
                         (change)="visualizationSelected.emit($event.value)">
  <mat-button-toggle *ngFor="let vis of visualizations" class="toggle" [value]="vis">
    {{ vis }}
  </mat-button-toggle>
</mat-button-toggle-group>
